import { render, staticRenderFns } from "./selectVison.vue?vue&type=template&id=8d7b46de&scoped=true&"
import script from "./selectVison.vue?vue&type=script&lang=js&"
export * from "./selectVison.vue?vue&type=script&lang=js&"
import style0 from "./selectVison.vue?vue&type=style&index=0&id=8d7b46de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7b46de",
  null
  
)

export default component.exports